import Lista from './Lista';

export const EmpresaLista = Lista;
